export default __webpack_public_path__ + "static/project4-8e756396ddd4c57a9efaf30413511363.jpg";